import * as Immutable from 'immutable';
import * as React from 'react';
import { Filter } from 'react-table';
import { Loader } from 'semantic-ui-react';

import { AlphaColumn } from '../../reducers/AlphasReducer/AlphasReducer.types';

import './Alphas.scss';
import AlphaDetailsContainer from './AlphasDetails/AlphaDetailsContainer';
import AlphaTable from './AlphaTable/AlphaTable';
import { AlphaTabTypeValue } from '../../shared/constants';

interface AlphasMainProps {
  handleHideDetail: () => void;
  handleShowDetail: (alphaIndex: string) => void;
  handleSetCurrentAlpha: (alphaIndex: string) => void;
  alphaDetail: any;
  isLoading: boolean;
  isOpenSelectColumns: boolean;
  optionsModal: Immutable.List<AlphaColumn>;
  handleCheckBox: (e: any, d: Object) => void;
  handleApply: (e: any) => void;
  handleReset: (e: any) => void;
  handleClosePopup: () => void;
  handleOpen: () => void;
  handleVisualization: (id: string) => void;
  handleFavorite: (id: string) => void;
  type: AlphaTabTypeValue;
  dataAddToList: any;
  handlePageChange: (pageIndex: number) => void;
  handlePageSizeChange: (pageSize: number) => void;
  handleFilteredChange: (newFiltering: Filter[], column: any, value: any) => void;
  currentPage: number;
  pageSize: number;
  totalPages: number;
  sort?: string;
  order: boolean;
  handleSortChange: (id: string) => void;
  handleSetSort: (id: string, isAscending: boolean) => void;
  handleSingleCheckbox: (data: any) => void;
  handleBulkCheckbox: () => void;
  bulkAlphas: string[];
  allChecked: boolean;
  filters: any;
  fetchingTags: boolean;
  handleFilterBlur: () => void;
  filtersUpdated: boolean;
  openModalCloseProperties: boolean;
  handleCancelCloseAlphaProperties: () => void;
  handleNotSaveCloseAlphaProperties: () => void;
  pageSizeLimit: number;
  handleDeleteAlphas: (alphas: any) => void;
  changePathToAlphas: () => void;
  alphasChoicesOptions: any;
  handlerShowDetail: (alphaDetail: string) => void;
  nextAlphaDetail: string;
}

const AlphasMain = (props: AlphasMainProps) => (
  <section className="alphas">
    {props.isLoading || (props.fetchingTags && props.type === 'alphaList') ? (
      <div className="loader">
        <Loader active={true} inline="centered" size="massive" />
      </div>
    ) : (
      <div>
        {props.alphaDetail !== null && (
          <AlphaDetailsContainer
            handleHideDetail={props.handleHideDetail}
            handleFavorite={props.handleFavorite}
            handleVisualization={props.handleVisualization}
            openModalCloseProperties={props.openModalCloseProperties}
            handleCancelCloseAlphaProperties={props.handleCancelCloseAlphaProperties}
            handleNotSaveCloseAlphaProperties={props.handleNotSaveCloseAlphaProperties}
            handlerShowDetail={props.handlerShowDetail}
            nextAlphaDetail={props.nextAlphaDetail}
          />
        )}
        <div>
          <AlphaTable
            allChecked={props.allChecked}
            alphasChoicesOptions={props.alphasChoicesOptions}
            bulkAlphas={props.bulkAlphas}
            changePathToAlphas={props.changePathToAlphas}
            currentPage={props.currentPage}
            dataAddToList={props.dataAddToList}
            filters={props.filters}
            filtersUpdated={props.filtersUpdated}
            handleApply={props.handleApply}
            handleBulkCheckbox={props.handleBulkCheckbox}
            handleCheckBox={props.handleCheckBox}
            handleClosePopup={props.handleClosePopup}
            handleDeleteAlphas={props.handleDeleteAlphas}
            handleFavorite={props.handleFavorite}
            handleFilterBlur={props.handleFilterBlur}
            handleFilteredChange={props.handleFilteredChange}
            handleOpen={props.handleOpen}
            handlePageChange={props.handlePageChange}
            handlePageSizeChange={props.handlePageSizeChange}
            handleReset={props.handleReset}
            handleSetCurrentAlpha={props.handleSetCurrentAlpha}
            handleSetSort={props.handleSetSort}
            handleShowDetail={props.handleShowDetail}
            handleSingleCheckbox={props.handleSingleCheckbox}
            handleSortChange={props.handleSortChange}
            handleVisualization={props.handleVisualization}
            isOpenSelectColumns={props.isOpenSelectColumns}
            optionsModal={props.optionsModal}
            order={props.order}
            pageSize={props.pageSize}
            pageSizeLimit={props.pageSizeLimit}
            sort={props.sort}
            totalPages={props.totalPages}
            type={props.type}
          />
        </div>
      </div>
    )}
  </section>
);

export default AlphasMain;
